import React from "react";

import {
	StandardBetSB,
	isPortrait
} from "@/modules/commonMobile";

import nary from "@/modules/nary";

import { IGameType } from "@/types/GlobalTypes";

interface IProps {
	game: IGameType;

	halfLeft?: boolean;
	halfRight?: boolean;

	activateBetGroup: (e: React.MouseEvent) => void;
}

//Copied from ShioBallsTabs
export default class FiveDTabs extends React.Component<IProps> {
	render() {
		const game = this.props.game;
		const activeBetGroup = game.activeBetGroup || "";

		//Components
		const topC5Set = (
			StandardBetSB({
				classes: "sl-machine-tab" + (activeBetGroup === `c5set` ? " active" : ""),

				betLabel: "C5 Set",
				betNum: "",
				betGroup: `c5set`,

				commonProps: game,
				onClick: this.props.activateBetGroup,

				isTopRow: true,

				disabled: false
			})
		);

		const top5DSet = (
			StandardBetSB({
				classes: "sl-machine-tab" + (activeBetGroup === `5dset` ? " active" : ""),

				betLabel: "5D Set",
				betNum: "",
				betGroup: `5dset`,

				commonProps: game,
				onClick: this.props.activateBetGroup,

				isTopRow: true,

				disabled: false
			})
		);

		const colokSet = (
			nary(5).map(item =>
				StandardBetSB({
					classes: "sl-machine-tab" + (activeBetGroup === `c${item}d1` ? " active" : ""),

					betLabel: "Colok " + item + "D",
					betNum: "",
					betGroup: `c${item}d1`,

					commonProps: game,
					onClick: this.props.activateBetGroup,

					isTopRow: true,

					disabled: false
				})
			)
		);

		const DSet = (
			nary(5).map(item =>
				StandardBetSB({
					classes: "sl-machine-tab" + (activeBetGroup === `d${item}` ? " active" : ""),

					betLabel: item + "D",
					betNum: "",
					betGroup: `d${item}`,

					commonProps: game,
					onClick: this.props.activateBetGroup,

					isTopRow: true,

					disabled: false
				})
			)
		);

		const fiftyFifty = (
			StandardBetSB({
				classes: "sl-machine-tab" + (activeBetGroup === `50-50` ? " active" : ""),

				betLabel: "50-50",
				betNum: "",
				betGroup: `50-50`,

				commonProps: game,
				onClick: this.props.activateBetGroup,

				isTopRow: true,

				disabled: false
			})
		);


		// console.log("Props on FDT", this.props);

		//Mobile Landscape
		if (this.props.halfLeft)
			return (
				<div className="tabs left">
					{topC5Set}
					{colokSet}
					{fiftyFifty}
				</div>
			);

		if (this.props.halfRight)
			return (
				<div className="tabs right">
					{top5DSet}
					{DSet}
				</div>
			);


		//Desktop & Mobile Portrait
		return (
			<div className="tabs left">
				{fiftyFifty}
				{!isPortrait() ? topC5Set : null}
				{colokSet}
				{isPortrait() ? topC5Set : null}

				{DSet}
				{top5DSet}
			</div>
		);
	}
}